import React from 'react';
import { Reveal } from './Reveal';
const STEPS = [{
  step: 'Step 01',
  title: 'Diagnose',
  body: 'We interview your best clients and audit your funnel to find exactly where revenue is leaking and where the biggest opportunities sit.'
}, {
  step: 'Step 02',
  title: 'Design',
  body: 'We build your messaging, automated systems, and conversion assets into one 12-month execution plan tailored to your growth stage.'
}, {
  step: 'Step 03',
  title: 'Deploy',
  body: 'We launch the systems and start driving qualified prospects — with first measurable lift typically inside 2–3 months.'
}, {
  step: 'Step 04',
  title: 'Scale',
  body: 'We optimize with data and AI, doubling down on what converts and abandoning what does not, so growth compounds sustainably.'
}];
export function Method() {
  return <section id="method" className="w-full bg-ink-950 py-24 text-white lg:py-32" data-id="element-99" data-mp="2wqcxkn4gxu6s">
      <div className="mx-auto max-w-container px-6 lg:px-8" data-id="element-100" data-mp="31pfvlnm17059">
        <Reveal className="max-w-2xl" data-id="element-101" data-mp="ped41rdkpqmh">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-400" data-id="element-102" data-mp="phitj7q46uiq">
            The method
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight lg:text-5xl" data-id="element-103" data-mp="fpd527z2mv8a">
            Our industry-tested growth process.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-104" data-mp="6ox3x55sw06l">
          {STEPS.map((item, i) => <Reveal key={item.step} delay={i * 0.08} data-id="element-105" data-mp="1q3m50jhdn0m" data-mpi={i}>
              <div className="relative h-full border-t border-gold-500/40 pt-6" data-id="element-106" data-mp="1oir79t98228">
                <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-400" data-id="element-107" data-mp="3swwnq5i6ro5o">
                  {item.step}
                </span>
                <h3 className="mt-3 font-display text-2xl font-semibold" data-id="element-108" data-mp="1r4s2fcv6zp3x">
                  {item.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-white/60" data-id="element-109" data-mp="1n2x0q79cn9pm">
                  {item.body}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}